import { DimConfigurationAdminPage } from "./DimConfigurationAdminPage"
import { useDimConfigurationAdminPageModel } from "./model/useDimConfigurationAdminPageModel"

export function DimConfigurationAdminPageConnector() {
  return <DimConfigurationAdminPage {...useDimConfigurationAdminPageModel()} />
}
